import { formatMetaData } from '../../../../../../../components/ToolkitV2/CardV2/helpers/formatMetaData/formatMetaData';

import { ORIENTATION } from '../../../../../../../components/ToolkitV2/CardV2/Card.typed';

import type { UseRelatedAdsCardArgs } from '../../../../../../../components/PageWrappers/AdDetails/components/RelatedAds/components/RelatedAdsCard/RelatedAdsCard.typed';

const useRelatedAdsCard = (props: UseRelatedAdsCardArgs) => {
  const {
    dealer,
    isGrid,
    mediaCount,
    photos,
    keyInfo,
    age,
    countyTown,
    county,
  } = props;

  const dealerHeader = {
    title: dealer?.name,
    subTitle: dealer?.franchiseType,
    logo: dealer?.logo?.small,
  };

  const orientationConfig = {
    orientationSmall: ORIENTATION.VERTICAL,
    orientationMedium: isGrid ? ORIENTATION.VERTICAL : ORIENTATION.HORIZONTAL,
  };

  const includesPhoto = mediaCount ? mediaCount > 0 : false;
  const imageSrc = photos && photos[0].small2 ? photos[0].small2 : undefined;
  const imageSrcWebp =
    photos && photos[0].small2Webp ? photos[0].small2Webp : undefined;

  const metaData = [
    ...(keyInfo ? keyInfo : []),
    age,
    countyTown ? `${countyTown}, ${county}` : county,
  ];

  const formattedMetaData = formatMetaData({
    metaData,
  });

  return {
    dealerHeader,
    orientationConfig,
    includesPhoto,
    imageSrc,
    imageSrcWebp,
    formattedMetaData,
  };
};

export { useRelatedAdsCard };
